// 兼容处理
function setHtml () {
  // 获取设备宽度
  var deviceWidth = document.documentElement.offsetWidth
  // 给html标签设置fontSize，就是给rem赋值
  if (deviceWidth > 500) {
    document.documentElement.style.fontSize = deviceWidth / 1920 * 16 + 'px'
  } else {
    document.documentElement.style.fontSize = deviceWidth / 375 * 16 + 'px'
  }
}
setHtml()
// 窗口大小变化的时候执行
window.onresize = setHtml



// WEBPACK FOOTER //
// ./src/rem.js